import styled from 'styled-components';

export const StyledVisitPanel = styled.div`
   display: flex;
   flex-direction: column;
   flex: 1;
   gap: 12px;
   max-height: 100%;
`;

StyledVisitPanel.displayName = 'StyledVisitPanel';
